module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "Home-Fanar.8564f94e.jpg" + "?" + Date.now();